import React, {useContext, useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import commentImg from "../../accets/img/comment.png";
import "./Comments.css"
import send from "../../accets/img/send.png";
import {Context} from "../../index";
import {createComment, fetchComment} from "../../http/CommentsAPI";

const Comments = ({oneTask, allUsers, show}) => {

    const {commentStore, userStore} = useContext(Context)

    const [commText, setCommText] = useState('')

    useEffect(() => {
            fetchComment().then(data => commentStore.setComments(data))
    }, [])

    const UserComments = commentStore.comments.filter(obj => obj.taskId === oneTask.id).map((comm) => {
        const withUserId = allUsers.filter(user => user['id'] === comm['userId'])
        const user = withUserId.reduce((acc, current) => {
            acc.push(current)
            return acc
        }, [])
        return {...comm, user: user}
    })

    let date = new Intl.DateTimeFormat("ru-RU", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    })

    const comment = {comment: commText, userId: userStore.user.id, taskId: oneTask.id}

    const addComment = (comment) => {
        createComment(comment)
        setCommText('')
        fetchComment().then(data => commentStore.setComments(data))
    }

    return (
        <>
            <div className="input__block input__block__comment" style={{marginTop: !show ? "160px" : "0"}}>
                <div className="name__input">Написать комментарий к задаче</div>
                <div className="comment__block">
                    <textarea onChange={event => setCommText(event.target.value)} value={commText} type="text"
                              placeholder="Комментарий..."/>
                    {commText === ''
                        ?
                        <div className="comment__btn__no__text">
                            <img src={send} alt={send}/>
                        </div>
                        :
                        <div className="comment__btn" onClick={() => addComment(comment)}>
                            <img src={send} alt={send}/>
                        </div>
                    }

                </div>
            </div>

            {UserComments.map(comm =>
                <div key={comm.id} className="comment__resp__block">
                    <div className="comment__resp__name__date__block">
                        <div className="comment__resp__name__block">
                            <div className="comment__resp__logo">
                                <img src={commentImg} alt={commentImg}/>
                            </div>
                            {comm.user.map(user =>
                                <div key={user.id} className="comment__resp__name">
                                    <div className="comment__resp__fn">{user.firstName}</div>
                                    <div className="comment__resp__fn">{user.secondName}</div>
                                </div>
                            )}
                        </div>
                        <div className="comment__resp__date">{date.format(Date.parse(comm.createdAt))}</div>
                    </div>
                    <div className="comment__resp__text">{comm.comment}</div>
                </div>
            )}
        </>
    );
};

export default observer(Comments);